// @flow
import Loadable from 'react-loadable';
import LoadableLoadingPage from 'pages/LoadableLoadingPage';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "GroupPageContainer" */ './GroupPageContainer'),
  loading: LoadableLoadingPage
});
